export const AD_UNITS = {
    /* Import only one top billboard */
    all: {
        topBillboard: {
            unitPath: '/23343758370/all_top_billboard',
            divId: 'div-gpt-ad-1782568158718-0'
        }
    },
};
